const TONE = {
  low: {
    dot: 'bg-[#94a3b8]',
    selected:
      'border-[rgba(148,163,184,0.42)] bg-[rgba(148,163,184,0.06)]',
  },
  medium: {
    dot: 'bg-[#7ed3f7] shadow-[0_0_0_2px_rgba(126,211,247,0.18)]',
    selected:
      'border-[rgba(126,211,247,0.42)] bg-[rgba(126,211,247,0.06)]',
  },
  high: {
    dot: 'bg-[#fbbf24] shadow-[0_0_0_2px_rgba(251,191,36,0.18)]',
    selected:
      'border-[rgba(251,191,36,0.45)] bg-[rgba(251,191,36,0.08)]',
  },
  critical: {
    dot: 'bg-[#ff7d7d] shadow-[0_0_0_2px_rgba(239,68,68,0.18)]',
    selected:
      'border-[rgba(239,68,68,0.45)] bg-[rgba(239,68,68,0.08)]',
  },
};

/**
 * Prototype `.req-modal-priority` 2×2 importance cards.
 *
 * @param {object} props
 * @param {{ value: string, label: string, description: string }[]} props.options
 * @param {string} props.value
 * @param {(next: string) => void} props.onChange
 */
function PriorityCardGrid({ options, value, onChange }) {
  return (
    <div className="grid grid-cols-1 gap-[7px] sm:grid-cols-2">
      {options.map((option) => {
        const selected = value === option.value;
        const tone = TONE[option.value] ?? TONE.medium;

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.value)}
            className={[
              'flex items-start gap-[9px] rounded-[8px] border px-[11px] py-[9px] text-left transition-colors',
              selected
                ? tone.selected
                : 'border-edge bg-black/[0.02] hover:border-content-muted dark:bg-white/[0.022]',
            ].join(' ')}
          >
            <span
              aria-hidden="true"
              className={['mt-[5px] h-2 w-2 shrink-0 rounded-full', tone.dot].join(' ')}
            />
            <span className="min-w-0 flex-1">
              <span className="block text-[12px] font-bold tracking-[-0.005em] text-content">
                {option.label}
              </span>
              <span className="mt-0.5 block text-[11px] leading-[1.45] text-content-faint">
                {option.description}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default PriorityCardGrid;
